"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { Paragraph } from "@ui/paragraph";
import type { OUT_OF_STOCK_ITEM, StockStatusProps } from "../Stock.types";
import { stockStatusVariants } from "../Stock.utils";
import StockIndicator from "./StockIndicator";

export default function OutOfStockItem({
  status,
  config,
}: {
  status: OUT_OF_STOCK_ITEM;
  config: StockStatusProps;
}) {
  const t = useTranslate();
  const { type, className } = config;

  const { root: rootSlot, explanation: explanationSlot } = stockStatusVariants({
    type,
  });

  if (type === "pdp") {
    return (
      <div className={className}>
        <div className={rootSlot()}>
          <StockIndicator status={status.code} />
          <span className="inline-block">{t("outOfStock")}</span>
        </div>
        <Paragraph className={explanationSlot()}>
          {t("outOfStockExplanation")}
        </Paragraph>
      </div>
    );
  }

  return (
    <div className={rootSlot({ className })}>
      <StockIndicator status={status.code} />
      <span className="inline-block">{t("outOfStock")}</span>
    </div>
  );
}
